import React, { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Field, change } from 'redux-form'
import { Input } from '../../form'
import { required } from '../../form/FormValidations'

const PromotionEligibilitiesField = ({ fields, meta, formName, data = [], fieldValues }) => {
  const dispatch = useDispatch()
  const [open, setOpen] = useState(false)
  const nodeRef = useRef(null)
  const options = data || []
  const label = fieldValues?.custom_label || 'Promotion Eligibility'
  const form = formName || meta?.form

  useEffect(() => {
    const handleOutside = (e) => {
      if (nodeRef.current?.contains(e.target)) return
      setOpen(false)
    }
    if (open) document.addEventListener('mousedown', handleOutside)
    return () => document.removeEventListener('mousedown', handleOutside)
  }, [open])

  if (fieldValues && fieldValues.visible?.toString() !== 'true') return null

  const rows = fields.getAll() || []
  const selectedTypes = rows.map((item) => item?.eligibility_type).filter(Boolean)

  const setRows = (next) => {
    if (!form) return
    dispatch(change(form, fields.name, next))
  }

  const removeType = (eligibilityType) => {
    setRows(rows.filter((row) => row?.eligibility_type !== eligibilityType))
  }

  const toggleType = (type) => {
    if (selectedTypes.includes(type)) {
      removeType(type)
      return
    }
    setRows([...rows, { eligibility_type: type, eligibility_metric: '' }])
  }

  return (
    <div className="row mx-0 bg-white shadow-sm">
      <div className="col-12 px-5">
        <div className="py-6 border-bottom border-light d-flex justify-content-between align-items-center">
          <h6 className="text-rap mb-0">{label}</h6>
        </div>
      </div>

      <div className="col-12 px-7 pt-5">
        <div className="row">
          <div className="col-6 form-group">
            <label>Select eligibility</label>
            <div
              className="dropdown border position-relative rounded form-control"
              style={{ height: 'auto', minHeight: 'calc(1.5em + 0.75rem + 2px)' }}
              ref={nodeRef}
            >
              <div
                className="d-flex align-items-center pointer"
                onClick={() => setOpen((v) => !v)}
              >
                <div className="flex-grow-1 py-2 pl-2">
                  <span className="place-visible text-muted">
                    {selectedTypes.length > 0
                      ? `${selectedTypes.length} selected`
                      : 'Select eligibility'}
                  </span>
                </div>
                <span
                  className="la la-angle-down text-muted px-3"
                  style={{ fontSize: '1rem' }}
                />
              </div>

              <div className={`dropdown-menu multiSelectDropdown overflow-auto w-100 px-5 ${open && 'show'}`}>
                {options.length === 0 ? (
                  <div className="text-muted py-3 text-center">No options configured</div>
                ) : (
                  options.map((opt) => (
                    <div
                      key={opt.value}
                      className="custom-control custom-checkbox mx-3"
                      onMouseDown={(e) => {
                        e.preventDefault()
                        e.stopPropagation()
                        toggleType(opt.value)
                      }}
                    >
                      <input
                        type="checkbox"
                        className="custom-control-input"
                        checked={selectedTypes.includes(opt.value)}
                        onChange={() => {}}
                      />
                      <label className="custom-control-label pointer">{opt.value}</label>
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>

          {fields.map((member, index) => {
            const item = fields.get(index)
            if (!item) return null
            return (
              <React.Fragment key={item.eligibility_type || index}>
                <Field name={`${member}.eligibility_type`} component="input" type="hidden" />
                <Field
                  name={`${member}.eligibility_metric`}
                  component={Input}
                  label={
                    <span>
                      {item.eligibility_type} <span className="text-danger">*</span>
                    </span>
                  }
                  type="text"
                  placeholder="#"
                  className="form-control"
                  wrapperClasses="col-6 form-group"
                  validate={[required]}
                />
              </React.Fragment>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default PromotionEligibilitiesField
